import { useStore } from 'vuex'
import { ClientType } from '@/modules/auth/types/authTypes'

export default function useClient(): ClientType {
	const store = useStore()
	return store.state.auth.user?.client?.attributes
}
